import classNames from "classnames";
import { ButtonVariant, CoButton } from "components/CoButton";
import OpenSidebarButton from "components/TopBar/OpenSidebarButton";
import { useSidebar } from "hooks/useSidebar";
import { useAppSelector } from "hooks/useStore";
import router from "next/router";
import React, { ReactNode } from "react";

interface HeaderProps {
  /**
   * The main title displayed in the header
   */
  title: string;
  /**
   * Action items (buttons, links, etc.) to be displayed on the right side
   */
  actions?: ReactNode;
  /**
   * Optional className for additional styling
   */
  className?: string;
  /**
   * Whether to show the back button
   */
  showBackButton?: boolean;
}

export const Header: React.FC<HeaderProps> = ({
  title,
  actions,
  className = "",
  showBackButton = false,
}) => {
  const isMobile = useAppSelector((state) => state.setting.isMobile);
  const { isSidebarOpen } = useSidebar();

  return (
    <header
      className={`flex items-center sticky top-0 z-10 w-full min-h-header bg-bg-base border-b ${className}`}
    >
      <div
        className={classNames(
          "flex items-center justify-between h-full w-full",
          showBackButton || !isSidebarOpen
            ? "pl-2 pr-4 lg:pl-4 lg:pr-6"
            : "px-4 lg:px-6"
        )}
      >
        <div className="flex items-center">
          {isMobile || !isSidebarOpen ? (
            <div className="mr-2">
              <OpenSidebarButton />
            </div>
          ) : showBackButton ? (
            <CoButton
              className="lg:mr-4 mr-1"
              onClick={() => router.back()}
              variant={ButtonVariant.Flat}
              underline={false}
              icon="icon-arrow-left"
              size="sm"
            />
          ) : null}
          <h1 className="text-lg font-bold text-fg-base truncate">{title}</h1>
        </div>

        {actions && <div className="flex items-center gap-3">{actions}</div>}
      </div>
    </header>
  );
};

export default Header;
